"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNumberInput = exports.formatValue = exports.valueToNumeric = exports.numericToValue = exports.isNumeric = void 0;
const tslib_1 = require("tslib");
const numeral_1 = (0, tslib_1.__importDefault)(require("numeral"));
const react_1 = require("react");
const defaultFormat = '0,0[.][0000]';
const defaultPattern = /[^\d.,-]/g;
const defaultValue = '';
function isNumeric(value = defaultValue) {
    const val = typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
    return !isNaN(val) && isFinite(val);
}
exports.isNumeric = isNumeric;
function numericToValue(value = defaultValue) {
    if (typeof value !== 'number' && !value)
        return (0, numeral_1.default)(value).value();
    return (0, numeral_1.default)(value).value();
}
exports.numericToValue = numericToValue;
function valueToNumeric(value = defaultValue, format = defaultFormat) {
    return (0, numeral_1.default)(typeof value === 'string' ? value.replace(defaultPattern, '') : value).format(format);
}
exports.valueToNumeric = valueToNumeric;
function formatValue(value, format) {
    return valueToNumeric(value, format);
}
exports.formatValue = formatValue;
function useNumberInput(opts) {
    const [value, setValue] = (0, react_1.useState)(opts.value);
    const [isFocussed, setIsFocussed] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (isFocussed)
            return;
        setValue(() => valueToNumeric(opts.value, opts.format));
    }, [opts.value, isFocussed, opts.format, setValue]);
    const handleFocus = (0, react_1.useCallback)((e) => {
        const numberValue = numericToValue(value);
        setValue(() => numberValue);
        e.target.value = numberValue.toString();
        e.target.select();
        setIsFocussed(() => true);
        if (opts.onFocus)
            opts.onFocus(e);
    }, [setIsFocussed, opts.onFocus, value, setValue]);
    const handleBlur = (0, react_1.useCallback)((e) => {
        setValue(value => valueToNumeric(value, opts.format));
        setIsFocussed(() => false);
        if (opts.onBlur)
            opts.onBlur(e);
    }, [setIsFocussed, setValue, opts.onFocus, opts.format]);
    const handleChange = (0, react_1.useCallback)((e) => {
        setValue(e.target.value);
        const val = numericToValue(e.target.value);
        if (opts.onChange)
            opts.onChange(opts.asString ? String(val || defaultValue) : val, e);
    }, [opts.asString, opts.onChange, opts.format, setValue]);
    return {
        value,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: isFocussed ? 'number' : undefined
    };
}
exports.useNumberInput = useNumberInput;
//# sourceMappingURL=useNumberInput.js.map